import {
  createListStrategy,
  type DynamicComponent,
  type ListStrategyFactoryOptions
} from '@dec/shared';
import { useGetGlobalTaxReturnValues } from 'app/modules/FormDefinition/services/signalr.hooks';

import { ObjectRequired } from '../../../../../../core/validations/common';
import { useCatalogList } from '../../../../../Parameters/Catalog/Catalog/useCatalog';
import { ChangeComponent } from '../../../ChangeComponent';

const options: ListStrategyFactoryOptions = {
  ChangeComponent,
  requiredValidation: ObjectRequired,
  useCatalogList,
  useRuntime: useGetGlobalTaxReturnValues
};
export default createListStrategy(options) as DynamicComponent;
